var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    _vm.item.AdvocacyAlertUrl != "" ? "a" : "a",
    {
      tag: "component",
      staticClass: "card card-horizontal card-outer card-callout",
      attrs: {
        href: _vm.item.AdvocacyAlertUrl,
        target: _vm.item.Url.indexOf("/") == 0 ? "_self" : "_blank"
      }
    },
    [
      _c("div", { staticClass: "card-content" }, [
        _c("span", { staticClass: "icon icon-arrow-right" }),
        _vm._v(" "),
        _vm.item.AdvocacyAlertTitle
          ? _c("h2", [_vm._v(_vm._s(_vm.item.AdvocacyAlertTitle))])
          : _vm._e(),
        _vm._v(" "),
        _vm.item.PreviewText
          ? _c("p", [
              _vm._v(_vm._s(_vm.item.PreviewText) + " "),
              _c("span", { staticClass: "cta-link no-left-margin" }, [
                _vm._v("Take Action")
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.item.CategoryDisplayNames && _vm.item.CategoryDisplayNames.length
          ? _c("div", { staticClass: "card-tags" }, [
              _c("span", [_vm._v("Topics:")]),
              _vm._v(" "),
              _c(
                "ul",
                _vm._l(_vm.item.CategoryDisplayNames, function(category) {
                  return _c("li", [_vm._v(_vm._s(category))])
                }),
                0
              )
            ])
          : _vm._e()
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }